import React, { useContext, useMemo } from 'react';
import styled from 'styled-components';

import { ConfigContext } from 'contexts/ConfigContext';
import { socialCompleteURL } from "utils/NwUtils";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { brands } from '@fortawesome/fontawesome-svg-core/import.macro';
import modelsCom from 'assets/imgs/modelsCom.png';
import { buildUrl } from 'utils/Socials';

const ModelSocialsWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    line-height: 1.15rem;
    flex: 1 1 0;
    justify-content: flex-start;
    align-items: center;
    gap: 1.5rem;

    .model-social-icon-container {
        font-size: 1.4rem;
        cursor: pointer;

        svg {
            color: ${props => props.theme.TextColor} ;
        }

        .models-com-icon {
            display: inline-block;
            width: 4rem;
            height: 1.4rem;
            background-size: contain;
            background-position: center center;
            background-repeat: no-repeat;
        }
    }
`

const SocialIcon = ({ social }) => {
    switch (social.toLowerCase()) {
        case "facebook":
            return <FontAwesomeIcon icon={brands('facebook')} />
        case "imdb":
            return <FontAwesomeIcon icon={brands('imdb')} />
        case "instagram":
            return <FontAwesomeIcon icon={brands('instagram')} />
        case "linkedin":
            return <FontAwesomeIcon icon={brands('linkedin')} />
        case "modelscom":
            return <ModelsComIcon className="models-com-icon" />;
        case "tiktok":
            return <FontAwesomeIcon icon={brands('tiktok')} />
        case "tumblr":
            return <FontAwesomeIcon icon={brands('tumblr')} />
        case "twitter":
            return <FontAwesomeIcon icon={brands('twitter')} />
        case "vimeo":
            return <FontAwesomeIcon icon={brands('vimeo')} />
        case "youtube":
            return <FontAwesomeIcon icon={brands('youtube')} />
        default:
            return <span>{social}</span>;
    }
};

const ModelSocials = ({ model }) => {


    const onlyFirstOfType = true;
    const { clientConfig } = useContext(ConfigContext)
    const { socials } = clientConfig

    const availableSocials = useMemo(() => {
        let availableSocials = [];
        if (socials && !socials.hideAll && model.Socials && socials.showByType && socials.showByType.length > 0) {
            //loop in the socials.showByType array
            for (const socialType of socials.showByType) {
                if (onlyFirstOfType) {
                    const social = model.Socials.find(social => social.Type.toLowerCase() === socialType.toLowerCase());
                    if (social) {
                        availableSocials.push(social);
                    }
                } else {
                    const socials = model.Socials.filter(social => social.Type.toLowerCase() === socialType.toLowerCase());
                    for (const social of socials) {
                        availableSocials.push(social);
                    }
                }
            }
        }
        return availableSocials;
    }, [model, socials]);

    const handleOpenSocial = socialLink => () => {
        window.open(socialLink);
    };

    return (
        <ModelSocialsWrapper className="model-socials-wrapper">
            {availableSocials.map(social => (
                <div className="model-social-icon-container" key={social.ID} onClick={handleOpenSocial(buildUrl(social.Type, social.Url))}>
                    <SocialIcon social={social.Type} size='small' />
                </div>
            ))}
        </ModelSocialsWrapper>
    );
};

const ModelsComIcon = styled.div`
    background-image: url(${modelsCom});
`

export default ModelSocials;
